import { Component, OnInit, Input } from '@angular/core';
import { MapPoint } from '../../map/map.component';
import { ModalComponent } from '../modal.component';
import { ModalService } from '../../../services/modal/modal.service';
import {AppSettingsService} from "../../../services/app-settings/app-settings.service";
import {UpaService} from "../../../services/upa/upa.service";
import {GenericEvent} from "../../../models/genericEvent";

@Component({
  selector: 'map-modal',
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss'],
})
export class MapModalComponent extends ModalComponent {
  @Input() mapPoints: MapPoint[];

  public wasOpened: boolean = false;

  constructor(
      protected modalService: ModalService,
      private appSettingsService: AppSettingsService,
      private upaService: UpaService
  ) {
    super(modalService);
  }

  onShow() {
    super.onShow();
    this.wasOpened = true;
    this.trackUpaMapEvt()
  }


  private trackUpaMapEvt(): void {
    this.upaService.track(GenericEvent.newUserAction('showMap', 'click', {
      channel: this.appSettingsService.getChannel(),
      site: this.appSettingsService.getSite(),
      lang: this.appSettingsService.getLanguage(),
      userId: this.appSettingsService.getUserId()
    }));
  }
}
